import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FCMService, AppFooterComponent } from '@shared';
import { environment } from '../environments/environment';
import { ToastContainerComponent } from './core/components/toast-container.component';

@Component({
  selector: 'admin-root',
  imports: [RouterOutlet, ToastContainerComponent, AppFooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'admin';
  private readonly fcmService = inject(FCMService);

  async ngOnInit(): Promise<void> {
    // Set VAPID key from environment
    this.fcmService.setVapidKey(environment.fcmVapidKey || null);
    
    // Initialize FCM
    await this.fcmService.initialize();
    
    // Request permission early (before login) - better UX
    await this.fcmService.requestNotificationPermission();
    
    // Get token when user is authenticated (after login)
    this.fcmService.initializeForUser().subscribe({
      next: (token) => {
        if (token) {
          console.log('[Admin App] FCM token registered');
        }
      },
      error: (error) => {
        console.error('[Admin App] FCM initialization error:', error);
      }
    });

    // Listen for foreground messages
    this.fcmService.onMessage().subscribe((payload) => {
      console.log('[Admin App] Foreground notification:', payload);
      if (payload.notification) {
        // Show notification
      }
    });
  }
}
